module.exports = __webpack_public_path__ + "img/BWWS.afe8f457.png";